import * as React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import { Toast } from "primereact/toast";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { InputFormat } from "../../Landing/Components/FormOptions/InputFormat";
import { CheckboxFormat } from "../../Landing/Components/FormOptions/CheckboxFormat";
import DataTableTemplate from "../Components/DataTableTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Col, Row } from "react-bootstrap";
import { PanelContainer } from "../Components/PanelContainer";
import { fetchData } from "../Components/Utilities";
import Swal from "sweetalert2";
import SelectButtonFormat from "../../Landing/Components/FormOptions/SelectButtonFormat";
export const Features = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [showEditComponent, setShowEditComponent] = useState(false);
  const [defaultRows, setDefaultRows] = useState(20);
  const [pageData, setPageData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
  });

  const defaultValues = {
    Ftitle: "",
    Flink: "",
    Fsort: "",
    Ficon: "",
    FId: "",
    Fstatus: 1,
  };
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const schema = yup.object({
    Ftitle: yup
      .string()
      .required("عنوان وارد نشده است.")
      .min(3, "عنوان وارد شده نباید کمتر از 3 کاراکتر باشد."),
    Ficon: yup.string().required("آیکون وارد نشده است."),
    Flink: yup.string().required("لینک وارد نشده است."),
  });
  const {
    handleSubmit,
    reset,
    control,
    register,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });

  const cols = [
    {
      field: "Mob",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "Ftitle",
      header: "عنوان",
    },
    { field: "Flink", header: "لینک" },
    { field: "Fsort", header: " اولویت" },
    { field: "Fstatus", header: ",وضعیت نمایش" },
    {
      field: "CityName",
      header: "ویرایش",
      body: (data, options) => (
        <div className="my-1">
          <FontAwesomeIcon
            icon={"edit"}
            onClick={() => handleOpeEditItem(data)}
            className="icon-sm prime-bg text-white p-1 text-center rounded"
            color="gray"
          />
        </div>
      ),
    },
    {
      field: "CityName",
      header: "حذف",
      body: (data, options) => (
        <div className="my-1">
          <FontAwesomeIcon
            icon={"remove"}
            onClick={() => handleDelete(data?.FId)}
            className="icon-sm btn-danger bg-danger  p-1 text-white text-center rounded "
          />
        </div>
      ),
    },
  ];
  const onSubmit = async (data) => {
    let status;
    if (data?.Fstatus) {
      status = 1;
    } else {
      status = 0;
    }
    const bodyFormData = new FormData();
    bodyFormData.append("flink", data?.Flink);
    bodyFormData.append("ftitle", data?.Ftitle);
    bodyFormData.append("ficon", data?.Ficon);
    bodyFormData.append("fsort", data?.Fsort);
    bodyFormData.append("fstatus", status);

    if (selectedUserId) {
      bodyFormData.append("fid", selectedUserId);
    }
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "setfeatures",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.UserId === "0") {
        }
        SweetAlert({
          title: "",
          text: "ویژگی  با موفقیت ذخیره شد.",
          type: "success",
        });
        fetchData("getfeatures", bodyFormData, handleApiResponse);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      throw new Error("Cpanel private route Error: ", error.message);
    }
  };
  const getFeatures = () => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    fetchData("getfeatures", bodyFormData, handleApiResponse);
  };
  useEffect(() => {
    getFeatures();
  }, []);
  const handleApiResponse = (data) => {
    setPageData(data?.dt);
  };
  const handleOpeEditItem = (data) => {
    console.log(data);
    setShowEditComponent(true);
    if (data) {
      setIsEditMode(true);
      setSelectedUserId(data?.FId);
      reset({ ...defaultValues, ...data });
    } else {
      reset(defaultValues);
      setIsEditMode(false);
    }
  };

  const onpage = (event) => {
    setLazyState({
      first: event.first,
      rows: event.rows,
      page: event.page,
    });
    setDefaultRows(event.rows);
  };
  const toast = useRef(null);
  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "لغو شد",
      detail: "درخواست حذف لغو شد",
      life: 3000,
    });
  };
  const handleOpeDeleteItem = async (id) => {
    console.log(id);
    const bodyFormData = new FormData();
    bodyFormData.append("fid", id);
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "delfeatures",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        getFeatures();

        toast.current.show({
          severity: "info",
          summary: "تایید شد",
          detail: "درخواست شما انجام شد",
          life: 3000,
        });
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      show: true,
      title: "حذف ویژگی",
      text: "آیا می خواهید آیتم را حذف کنید؟",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      cancelButtonColor: "#d33",
      icon: "success",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await handleOpeDeleteItem(id);
      }
    });
  };
  const stOptions = [
    { label: "فعال", value: 1 },
    { label: "غیرفعال", value: 0 },
  ];
  return (
    <PanelContainer title={"افزودن/ ویرایش ویژگی ها"}>
      <div className="row text-right  p-sm-0  data-table">
        <DataTableTemplate
          lazyState={lazyState}
          // select='select'
          className={"table-border"}
          columns={cols}
          list={pageData}
          totalRecords={totalRecords}
          setlazyState={setLazyState}
          setDefaultDatatableRows={setDefaultDatatableRows}
          defaultDatatableRows={defaultDatatableRows}
          width="25rem"
          paginator={false}
        />
        <div className="col-6 mt-5 mb-2">
          <Button className="" onClick={() => handleOpeEditItem()}>
            افزودن
          </Button>
        </div>
      </div>
      {showEditComponent && (
        <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
          <div className="panel-heading prime-bg text-white text-center py-2">
            <span id="ContentPlaceHolder1_lblbannerheading ">
              {isEditMode ? "ویرایش ویژگی" : "افزودن ویژگی جدید"}
            </span>
          </div>
          <div className="panel-body">
            <Row>
              <Col className="col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="Fsort"
                  type={"tel"}
                  defaultValue={""}
                  label="اولویت"
                  errors={errors}
                />
              </Col>
              <Col className="col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="Ftitle"
                  type={"text"}
                  label="عنوان "
                  errors={errors}
                />
              </Col>
            </Row>

            <Row>
              <Col className="col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="Ficon"
                  type={"text"}
                  label="آیکون"
                  errors={errors}
                />
              </Col>
              <Col className="col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="Flink"
                  type={"text"}
                  label="لینک"
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col className="col-12 col-lg-6">
                {/* <CheckboxFormat
                  control={control}
                  name="Fstatus"
                  errors={errors}
                  type="checkbox"
                  label="وضعیت نمایش"
                /> */}
                <div className="d-flex flex-direction-column justify-content-start gap-2">
                  <Form.Label className="fw-bold pb-1">وضعیت</Form.Label>
                  <SelectButtonFormat
                    name={"Fstatus"}
                    options={stOptions}
                    control={control}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="col-12 col-lg-12">
                <Button type="submit">ذخیره</Button>
              </Col>
            </Row>
          </div>
        </Form>
      )}
    </PanelContainer>
  );
};
